import React, { useContext, useEffect, useState } from 'react';
import { Box, Grid, Typography, Divider } from '@mui/material';
import dayjs from 'dayjs';
import axios from 'axios';
import { useGrowSetup }  from '../../GrowSetupContext';
import { AuthContext }   from '../../components/signin/AuthContext';
import CombinedGraph     from '../../components/CombinedGraph';
import CustomDatePicker  from '../../components/CustomDatePicker';
import ActorAnalyticsCard from '../../components/ActorAnalyticsStatCard';

const ACTOR_CARDS = [
  { measure: 'Licht',   dict_val: 'licht',          trend: 'up'      },
  { measure: 'Abluft',  dict_val: 'abluft',         trend: 'neutral' },
  { measure: 'Umluft',  dict_val: 'umluft',         trend: 'up'      },
  { measure: 'Heizung', dict_val: 'heizung',        trend: 'neutral' },
];
const SENSOR_CARDS = [
  { measure: 'Sensor BME', dict_val: 'bme', trend: 'up'      },
  { measure: 'Sensor SHT', dict_val: 'sht', trend: 'neutral' },
];
const CTRL_CARDS = [
  { measure: 'Klimakontroller',  dict_val: 'klimakontroller',  trend: 'up' },
  { measure: 'Hydro Kontroller', dict_val: 'hydrokontroller',  trend: 'neutral' },
];

function SectionHeader({ children }) {
  return (
    <Box sx={{ mb: 2, mt: 3 }}>
      <Typography variant="overline" sx={{ color: '#76c442', fontWeight: 700, letterSpacing: '0.12em', fontSize: '0.7rem' }}>
        {children}
      </Typography>
      <Divider sx={{ mt: 0.5, borderColor: 'rgba(118,196,66,0.15)' }} />
    </Box>
  );
}

export default function AnalyticsPage() {
  const { grow_setup }  = useGrowSetup();
  const { token }       = useContext(AuthContext);
  const [gauges,    setGauges]  = useState({});
  const [timeFrom,  setFrom]    = useState(dayjs().subtract(1, 'day'));
  const [timeTo,    setTo]      = useState(dayjs());

  useEffect(() => {
    if (!grow_setup) return;
    const load = () => {
      axios.post(`/get_current_gauge_values/${grow_setup}`, { hello: 'world' }, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      }).then(r => setGauges(r.data || {})).catch(console.error);
    };
    load();
    const id = setInterval(load, 10000);
    return () => clearInterval(id);
  }, [grow_setup]);

  return (
    <Box>
      {/* Date pickers */}
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          mb: 3,
          p: 2,
          borderRadius: '14px',
          background: 'rgba(15,28,15,0.6)',
          border: '1px solid rgba(118,196,66,0.12)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <CustomDatePicker label="Startzeit" value={timeFrom} setValueOuter={setFrom} />
        <CustomDatePicker label="Endzeit"   value={timeTo}   setValueOuter={setTo}   />
      </Box>

      {/* Combined chart */}
      <Box
        sx={{
          borderRadius: '16px',
          overflow: 'hidden',
          border: '1px solid rgba(118,196,66,0.12)',
          background: 'rgba(15,28,15,0.7)',
          backdropFilter: 'blur(16px)',
          mb: 4,
          animation: 'fadeSlideUpCard 0.5s cubic-bezier(0.22,1,0.36,1) both',
        }}
      >
        <CombinedGraph grow_setup={grow_setup} time_from={timeFrom} time_to={timeTo} />
      </Box>

      {/* Aktoren */}
      <SectionHeader>Aktoren</SectionHeader>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {ACTOR_CARDS.map((c, i) => (
          <Grid item xs={12} sm={6} md={3} key={c.dict_val}>
            <Box sx={{ animation: `fadeSlideUpCard 0.5s cubic-bezier(0.22,1,0.36,1) ${i * 60}ms both` }}>
              <ActorAnalyticsCard
                {...c}
                gauge_value={gauges[c.dict_val]}
                grow_setup={grow_setup}
                issmall={0}
                value="0"
                interval=""
                data={[]}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Sensoren */}
      <SectionHeader>Sensoren</SectionHeader>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        {SENSOR_CARDS.map((c, i) => (
          <Grid item xs={12} sm={6} md={3} key={c.dict_val}>
            <Box sx={{ animation: `fadeSlideUpCard 0.5s cubic-bezier(0.22,1,0.36,1) ${i * 60}ms both` }}>
              <ActorAnalyticsCard
                {...c}
                gauge_value={gauges[c.dict_val]}
                grow_setup={grow_setup}
                issmall={0}
                value="0"
                interval=""
                data={[]}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Kontroller */}
      <SectionHeader>Kontroller</SectionHeader>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {CTRL_CARDS.map((c, i) => (
          <Grid item xs={12} sm={6} md={3} key={c.dict_val}>
            <Box sx={{ animation: `fadeSlideUpCard 0.5s cubic-bezier(0.22,1,0.36,1) ${i * 60}ms both` }}>
              <ActorAnalyticsCard
                {...c}
                gauge_value={gauges[c.dict_val]}
                grow_setup={grow_setup}
                issmall={0}
                value="0"
                interval=""
                data={[]}
              />
            </Box>
          </Grid>
        ))}
      </Grid>

      <style>{`
        @keyframes fadeSlideUpCard {
          from { opacity:0; transform:translateY(20px); }
          to   { opacity:1; transform:translateY(0);    }
        }
      `}</style>
    </Box>
  );
}
